<template>
  <div class="members ">
    <div class="member-top">
      <div class="member-top-bg ">
        <van-swipe
          class="pr member-cards-wrap"
          :loop="false"
          :show-indicators="false"
          :width="widthClient"
          ref="swipe"
          @change="changeIndex"
        >
          <van-swipe-item  v-for="item in listIndex" :key="item.vipId">
            <div
              class="member-cards pa"
              :style="'background:url(' + item.bg + ')  no-repeat;color:'+item.colorText"
            >
              <div class="cards-top flex pr">
                <img :src="item.icon" alt="等级图标" />
                <div class="cards-top-con flex">
                  <h3>{{item.vipName}}</h3>
                  <p class="fs12 block">{{ item.level === infos.level && infos.vipNo || ''}}</p>
                </div>
              </div>
              <div class="pa cards-bottom fs12">{{item.level === infos.level && infos.invalidTime || '去开通'}}</div>
            </div>
          </van-swipe-item>
        </van-swipe>
      </div>
    </div>

    <div class="member-bottom">
      <h2 class="pr">权益信息<i class="pa"></i></h2>
      <ul class="flex ">
        <li class="tc" v-for="(li ,i) in privilegeList " :key="i">
          <img :src="li.icon" alt="" />
          <h5 class="fs12">{{li.name}}</h5>
          <p class="line1">{{li.description}}</p>
        </li>
      </ul>
    </div>

    <div class="footer tc" @click="submit">
      <img v-if="!isDisabled" src="@/assets/imgs/members/free.png" alt="" />
      <button >{{btnText}}</button>
      <!-- :class="isDisabled ? 'disabled':''" -->
    </div>

    <!-- 底部弹窗 -->
    <van-popup
    v-model="isBuy"
    position="bottom"
    class="van-wrap"
    :style="{ height: '40%' }">
        <div class="lists">
            <div class="lists-item" 
                v-for="(item,i) in listType" 
                :class="item.checked ? 'checked' :'' "
                :key="i" 
                @click="selectTypes(item,i)">
                <img v-if="item.checked" src="@/assets/imgs/members/checked.png" alt="">
                <span>{{item.name}}</span>
                <i class="fr">￥{{priceYuan(item.discountsPrice)}}</i>
            </div>
        </div>
        <button @click="submitPopup">确定</button>
    </van-popup>


  </div>
</template>

<script>
import { getVipInfo ,getVipInfoList ,getVipClass} from '@/api/members'
import {priceYuan} from '@/libs/tool'

export default {
  name: "members",
  data() {
    return {
      widthClient: document.body.clientWidth - 35,
      index: 0,
      listIndex: [],
      infos:{},

      btnText:'立即开通',
      isDisabled:false,

      isBuy:false,  //购买弹窗的显示
      listType:[],
      privilegeList:[],  //权益信息
      checkedInfos:null,  //选中的价钱
    };
  },
  created() {
      this.getLists()
      this.getInfos()  
  },
  methods: {
    // 获取会员信息
    getInfos(){
       getVipInfo().then(reg=>{
          if(!reg.code){
            this.infos = reg.data
            this.index = this.infos.vipNo && Math.abs(this.infos.level - 5) || 0
            this.privilegeList = this.infos.privilegeList
            this.isDisabled = !!(this.infos.vipNo)
            this.btnText = this.infos.vipNo ? '去续费' :'立即开通'
            this.$refs['swipe'].swipeTo(this.index)
            this.getType(this.infos.vipId)
          }
        })

    },
    // 获取等级列表
    getLists() {
     const colorsText=['#F3D4A0' ,'#A56D55','#A88044','#7F7F7F','#526378'].reverse();
      getVipInfoList().then(res=>{
        res.data && res.data.forEach((el,i)=>{
          el.icon = require(`@/assets/imgs/members/icon${el.vipId}.png`)
          el.bg= require(`@/assets/imgs/members/bg${el.vipId}.png`)
          el.colorText=colorsText[i]
        })
        this.listIndex = res.data.reverse()
      })
    },
    priceYuan,
    // 获取等级的类型
    getType(val){
      getVipClass({vipId:val}).then(res=>{
          if(!res.code){
            this.listType = res.data
            this.listType && this.listType.forEach(rep=>{
               this.$set(rep ,'checked',false)
             })
          }
      })
    },
    // 切换等级的change
    changeIndex(index) {

      const singalItem = this.listIndex[index]
      let isExist = ((singalItem && singalItem.level) == this.infos.level)
      
      this.privilegeList = (singalItem && singalItem.privilegeList) || []
      this.index = index
      
      this.isDisabled = !!(this.infos.vipNo &&  isExist)
      this.btnText =  isExist && this.infos.vipNo ? '去续费' :'立即开通'

      this.getType(singalItem.vipId)

    },
    // 选择购买类型
    selectTypes(item,idx){
        this.listType.map(res=>res.checked = false)
        this.listType[idx].checked = true
        this.checkedInfos = this.listType[idx]
    },
    // 类型的，确定
    submitPopup(){
      if(!this.checkedInfos) return this.$toast('请选择开通的类型')
        const data = Object.assign({},this.listIndex[this.index] ,this.checkedInfos)
        // this.isBuy = false
        localStorage.setItem('SETORDERINFOS' , JSON.stringify(data))
        // query:{infos:encodeURIComponent(JSON.stringify(data)) }
        this.$router.push({name:'memberBuy',})
    },
    // 开通按钮点击
    submit(){
      // console.log(this.listType,777)
      if(!this.listType || (this.listType && this.listType.length === 0)) return this.$toast('暂无开通的类型，请切换会员，进行开通')
      // if(this.btnText  === '您已经开通') return
      this.isBuy = true
    }  
  }, 
};
</script>

<style lang="scss" scoped>
.member-top {
  background: #f5f5f7;
  padding-bottom: 32px;

  .cards-top-con{
    align-items: center;
    flex-wrap: wrap;
    h3{
      width: 100%;
    }
  }
  .member-cards-wrap {
    height: 150px;
    margin-left: 5%;
  }
  .member-top-bg {
    background: url("~@/assets/imgs/members/membersbg.png") no-repeat;
    background-size: cover;
    height: 127px;
    .member-cards {
      height: 130px;
      box-sizing: border-box;
      width: 96%;
      top: 15px;
      left: 0;
      right: 0;
      // background: url('~@/assets/imgs/members/bg1.png') no-repeat;
      background-size: 100% 100% !important;
      padding: 16px;
      box-sizing: border-box;
      color: #526378;

      .cards-top {
        // line-height: 22px;
        img {
          width: 36px;
          height: 36px;
          margin-right: 9px;
          vertical-align: top;
        }
        h3 {
          font-size: 18px;
          margin-bottom: 4px;
        }
      }
      .cards-bottom {
        bottom: 16px;
      }
    }
  }
}
.member-bottom {
  padding: 16px;

  h2 {
    font-size: 18px;

    i {
      display: inline-block;
      width: 40px;
      height: 6px;
      background: #e5d1b0;
      left: 38px;
      top: 16px;
      z-index: -1;
    }
  }

  ul {
    flex-wrap: wrap;
    justify-content: space-between;
    padding: 20px 0px;

    li {
      color: #111111;
      width: 33.33%;
      margin-bottom: 25px;
      line-height: 21px;
      img {
        width: 42px;
        height: 42px;
        margin-bottom: 5px;
      }
      p {
        font-size: 10px;
        color: #8a8d94;
      }
    }
  }
}
.footer {
  position: fixed;
  bottom: 20px;
  width: 100%;
  img {
    position: absolute;
    bottom: 30px;
    left: 55px;
    right: 0;
    margin: auto;
  }
  button {
    width: 90%;
    height: 44px;
    background: #364057;
    color: #ffffff;
    font-size: 16px;
    outline: none;
    border: none;
    border-radius: 44px;

    &.disabled{
        background: #C8C8C8 !important; 
    }
  }
}
.van-wrap{
    padding: 20px 16px;
    box-sizing: border-box;
    .lists{
        height: 80%;
        overflow-y: auto;
    }

    .lists-item{
        border: 1px solid #EBEBF1;
        background: #F9F9FC;
        border-radius: 8px; 
        padding: 12px 24px;
        font-size: 17px;
        color: #666666;
        margin-bottom: 12px;
        
        i{
            font-style: normal;
        }

        &.checked{
            box-shadow: 0px 12px 8px -10px rgba(74, 84, 158, 0.3);
            border: 1px solid #4A549E;
            position: relative;

            img{
                width: 27px;
                position: absolute;
                right: -2px;
                top: -1px;
            }
        }
    }

    button{
        width: 100%;
        line-height:40px;
        border: none;
        outline: none;
        background: #4A549E;
        color: #ffffff;
        border-radius: 40px;
    }
}
</style>
